/** Différents type de champ DateTime
 */
export enum DateTimeFieldType {
  Date = 'Date',
  DateTime = 'DateTime',
}
